module.exports = __webpack_public_path__ + "img/1F1ED-1F1F3.6fa3fa60.svg";